// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__I4GH3","iconWrap":"styles_iconWrap__zNSCI"};
module.exports.__checksum = "ce1f59b22b29"